'use strict';
import { Component, Inject, Input, EventEmitter, Output} from 'ng-metadata/core';
import {PushtoService} from '../pushto.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service'
import {isBrowserSafari} from '../../../infra/browserSniffer';
import {MediaQueries} from '../../../infra/mediaQueries.service';
import {LegantoService} from './leganto.service';


@Component({
    selector: 'prm-leganto',
    templateUrl: 'components/search/actions/legantoAction/leganto.html',
})

export class PrmLeganto implements OnInit{

    @Input() private item: Object;
    @Output() finishedLegantoEvent = new EventEmitter<void>();

    private selectedUserList: string;
    private userLists: string[];
    private selectedUserSection:string;
    private userSections: string[];
    private popupWin : Window;
    private pushToOptions: string[];
    private selectedPushToOption:string;
    private showLists = "show";
    private showSections: string;
    private responseLists = [];
    private noSectionsError: string;
    private list: string;
    private collection: string;
    private showPushToForm = "";
    private showSignIn = "";


    constructor(private pushtoService: PushtoService,
                private mtCache:MappingTablesCache,
                private mediaQueries: MediaQueries,
                @Inject('$document') private $document,
                public legantoService: LegantoService) {
        this.setPushOptions();
        this.selectedPushToOption = this.list;
        this.getListFromLeganto();
        this.legantoService.showTemplateType = "";
    }

    // Fetch lists from Leganto by userId using Leganto API
    private getListFromLeganto() {
        // User not sign in - show sign in message
        if(this.legantoService.isGuest()){
            this.legantoService.showTemplateType = "signIn";
        }
        // User signed in - fetch lists from Leganto
        else {
            let pushtoPromise = this.legantoService.getListFromLeganto();
            pushtoPromise.then((response)=>this.setUserLists());
        }
    }

    public setUserLists() {
        this.userLists = this.legantoService.getResponseLists();
            if(this.userLists.length > 0){
                this.legantoService.showTemplateType = "userSelection";
            }
            else {
                this.selectedPushToOption = this.collection;
            }

    }

    // Push the current record into Leganto list/collection by userId using Leganto API
    public pushRecord(event) {
        // in case of submitting to 'collection' - nullify the selected list and section (if exists)
        if(this.selectedPushToOption === this.collection){
            this.selectedUserList = "";
            this.selectedUserSection = "";
        }
        // in case of submitting to 'list' - won't do anything in case lists and section weren't selected
        else if (this.selectedPushToOption === this.list && (this.selectedUserList === "" || typeof(this.selectedUserList) === 'undefined' || this.selectedUserSection === "" || typeof(this.selectedUserSection) === 'undefined')){
            return;
        }

        let pushtoPromise = this.legantoService.pushRecord(this.selectedUserList, this.selectedUserSection);
        pushtoPromise.then((response)=>this.finishedLegantoEvent.emit(null));
        this.noSectionsError = "";
    }


    // when user changes the radio buttons neew to make sure that both 'Lists' and 'Sections'
    // dropdowns are displayed only for radio button 'List' and not for 'Collection'
    private changedPushToOption() {
        this.showLists      = (this.selectedPushToOption === this.list) ? 'show' : '';
        this.showSections   = (this.selectedPushToOption === this.list && typeof(this.selectedUserList) !== 'undefined' && this.selectedUserList !== "") ? 'show' : '';
        this.legantoService.statusMessage = "";

        this.setDisplayNoSectionsError();
        this.showSections = (typeof(this.userSections) !== 'undefined' && this.userSections.length > 0 && this.selectedPushToOption === this.list) ? "show" : "";

        this.setPushAllowed();
    }

    // Set new sections for the dropdown when selected list was change so
    // sections will match to selected list
    private changedUserList() {
        this.selectedUserSection = "";

        let sectionsNames = [];
        let mythis = this;
        angular.forEach(mythis.legantoService.getResponseLists(), function(list){
            if(list.id === mythis.selectedUserList){
                mythis.userSections = list.sections;
            }
         });

       this.setDisplayNoSectionsError();

       this.showSections = this.userSections.length > 0 ? "show" : "";

       this.legantoService.statusMessage = "";

       this.setPushAllowed();
    }

    private changedUserSection() {
        this.legantoService.statusMessage = "";

        this.setPushAllowed();
    }

    private setPushOptions() {
        this.list = this.legantoService.translations['fulldisplay.command.pushto.option.LegantoPushTo.list'];
        this.collection = this.legantoService.translations['fulldisplay.command.pushto.option.LegantoPushTo.collection'];
        this.pushToOptions = [ this.collection, this.list ];
    }

    // show warning to indicate the user that the selected list doesn't have any sections
    private setDisplayNoSectionsError() {
        this.noSectionsError = ( typeof(this.userSections) !== 'undefined' && this.userSections.length == 0 &&
                                 typeof(this.selectedPushToOption) !== 'undefined' && this.selectedPushToOption === this.list &&
                                 typeof(this.selectedUserList) !== 'undefined' && this.selectedUserList !== "") ? "show" : "";
    }


    private setPushAllowed(){
        // Submit button will be enabled only if the radio button set to 'show and both dropdown lists was selected OR
        // if the radio button is set to 'collection'
        if( ( ( typeof(this.selectedPushToOption) !== 'undefined' && this.selectedPushToOption === this.list ) &&
              ( typeof(this.selectedUserSection) !== 'undefined' && this.selectedUserSection !== "" ) &&
              ( typeof(this.selectedUserList) !== 'undefined' && this.selectedUserList !== "" )
            ) ||
            ( typeof(this.selectedPushToOption) !== 'undefined' && this.selectedPushToOption === this.collection )
          ){
            this.legantoService.pushAllowed = true;
        }
        else {
            this.legantoService.pushAllowed = false;
        }
    }

    ngOnInit() {
        if( this.legantoService.isGuest() ){
            this.legantoService.showTemplateType = "signIn";
            this.pushAllowed = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/legantoAction/leganto.directive.ts